<div class="body" (mouseenter)="isHovered.set(true)" (mouseleave)="isHovered.set(false)">

  <!-- Product Image -->
  <ng-container>
    <gea-shop-product-item-badge [badge]="badge()"></gea-shop-product-item-badge>
    @let ariaLabel = product().getSwatchValue(variantHovered()?.variantId)?.title;
    <a class="item-link" [routerLink]="[ '/' + product().slug + '.html' ]"
      [attr.aria-label]="product().title + (ariaLabel ? ' ' + ariaLabel : '')"
      fragment="{{ getSwatchParams(variantHovered(), 0) }}">
      @let pic = picture();
      @let pictureScopes = pic?.scopes ?? [];
      <div class="image-container" [class.action]="pictureScopes.includes('action')">
        <!-- image -->
        @if (pic) {
          <ng-container #productImage>
            @if (pic.slug) {
              <img
                [ngSrc]="pic.slug"
                [attr.alt]="pic.alt"
                class="img-fluid"
                [class.action]="pictureScopes.includes('action')"
                ngSrcset="200w, 300w, 400w, 750w"
                sizes="{{ getSizeList() }}"
                fill
                />
            }
          </ng-container>
        } @else {
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180.119 139.794" class="img-fluid">
            <g paint-order="fill markers stroke" transform="translate(-13.59 -66.639)">
              <path fill="#fff" d="m118.507 133.514-34.249 34.249-15.968-15.968-41.938 41.937h152.374z" opacity=".675"/>
              <circle cx="58.217" cy="108.555" r="11.773" fill="#fff" opacity=".675"/>
              <path fill="none" d="M26.111 77.634h152.614v116.099H26.111z"/>
            </g>
          </svg>
        }

        <!-- placeholder -->
      </div>
    </a>
  </ng-container>

  <!-- Variants mode == list (swatchColor) -->
  @if (scope == 'list') {
    <div class="variants" (mouseleave)="variantHovered.set(undefined)">
      <ng-container *ngTemplateOutlet="variantsTemplate"></ng-container>
    </div>
  }

</div>

<!-- Name | Price -->
<div class="detail">
  @if (scope != 'search') {
    <h5 class="title" [attr.aria-level]="headingLevel()">{{ product().title }}</h5>
  }
  @if (scope == 'search') {
    <h5 class="title" [attr.aria-level]="headingLevel()" [ngbTooltip]="product().title.length >= 31 ? product().title : undefined" placement="auto" container="div.detail">{{ product().title | shortenText:31 }}</h5>
  }
  <!-- Variants mode == search (swatchColor) -->
  @if (scope == 'search' && product() && product().variants && product().variants.length > 1) {
    <div class="variants">
      <label>Farbe:</label>
      <ng-container *ngTemplateOutlet="variantsTemplate"></ng-container>
    </div>
  }
  <p class="price">
    <gea-shop-product-single-price [product]="product()"></gea-shop-product-single-price>
  </p>
</div>

<ng-template #variantsTemplate>
  @if (product() && getSwatchVariants()) {
    <ul>
    @for (variant of getSwatchVariants(); track variant; let j = $index) {
      <li>
      @if (shouldShowSwatch(j)) {

        @if (variant.swatchImage) {
          <a [class.morethanfour]="getSwatchVariants().length > 5"
            [routerLink]="[ '/' + product().slug + '.html']"
            [attr.aria-label]="product().title + ' - ' + (product().getSwatchValue(variant.variantId)?.title || 'Farbvariante')"
            fragment="{{ getSwatchParams(variant, j) }}"
            (mouseenter)="variantHovered.set(variant)">
            <span>
              <gea-shop-product-swatch-color
                [swatchImage]="variant.swatchImage"
                [colorOption]="product().getSwatchValue(variant.variantId)"
                [active]="presetVariant()?.variantId == variant.variantId"
              ></gea-shop-product-swatch-color>
            </span>
          </a>
        }

      } @else {
        @if (j == 5) {
          <a [routerLink]="[ '/' + product().slug + '.html']" class="morethanfour"
            [attr.aria-label]="product().title + ' - ' + mapNumberToLocaleString(getSwatchVariants().length - 4, true, true) + ' weitere Farbvarianten'">
            <span [ngbTooltip]="mapNumberToLocaleString(getSwatchVariants().length - 4, true, true) + ' weitere Varianten vorhanden'">
              + {{ getSwatchVariants().length - 4 }}
            </span>
          </a>
        }
      }
      </li>
    }
    </ul>
  }
</ng-template>